module.exports = __webpack_public_path__ + "media/slv/favicon-c44f4b92.ico";